<template>
    <v-flex class="pagina-curso" xs12 fill-height>
        <header-app></header-app>
        <nav-menu-app :mod="mod"></nav-menu-app>
        <div class="contenido">
            <transition name="fade">
                <component key="item" :is="'mod' + $route.params.unipage + '-app'"></component>
            </transition>
        </div>
    </v-flex>
</template>
<script>
    import mod0 from "./mod0";
    import mod1 from "./mod1";
    import mod2_1 from "./mod2-1";
    import mod2 from "./mod2";
    import mod3 from "./mod3";
    import mod5 from "./mod5";
    import mod6 from "./mod6";
    import mod7 from "./mod7";
    import mod8 from "./mod8";
    import mod9 from "./mod9";
    import mod10 from "./mod10";
    import mod21 from "./mod21";
    import mod20 from "./mod20";

    export default {
        components: {
            "mod0-app": mod0,
            "mod1-app": mod1,
            "mod2-app": mod2_1,
            "mod3-app": mod2,
            "mod4-app": mod3,
            "mod5-app": mod5,
            "mod6-app": mod6,
            "mod7-app": mod7,
            "mod8-app": mod8,
            "mod9-app": mod9,
            "mod10-app": mod10,
            "mod21-app": mod21,
            "mod20-app": mod20,
        },
        data() {
            return {
                noOfPages: 11,
                mod: {
                    modurl: "unidad2"
                },
                verdialogo: 0,
                nombreAnimacion: '',
                cambioAction: ''
            };
        },
        computed: {
            currentPage() {
                return Math.floor(this.$route.params.unipage);
            },
            subModName() {
                return this.$store.state.subTema;
            },

        },
        methods: {},
        // mounted y updated: Carga el número de pantallas en el store para que las flechas de navegación funcionen
        mounted() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
        },
        updated() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);

        }

    };
</script>
<style lang="scss">
    // NOT SCOPED !!
    @import "../../sass/globals";

    .pagina-curso {
        background-image: url("../../assets/fondo/textura-2.svg");
        background: #F7F7F9;
        background-repeat: no-repeat;
        background-position: 95% 90%;
        background-size: 20%;
        height: 100vh;
        overflow: overlay;
        transition: all 0.3s ease-in-out;
        padding: 0px;

        .contenido {
            max-width: 100%;
            // width: 1100px;
            margin: auto;
            position: relative;
            overflow: overlay;
            height: calc(100vh - 100px);
            max-height: auto;
            // padding: 0px 15px 0px 15px;
            padding: 0px 10% 0px 10%;
            margin-top: 50px;

            @media screen and (max-width: 500px) {
                max-width: 100%;
            }
        }

        @media screen and (max-width: 700px) {
            background-size: 40%;
        }

        @media screen and (max-width: 500px) {
            background-size: 50%;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 2s ease-out;
        position: absolute;
        max-height: 100%;
        min-height: 100%;
        max-width: calc(100% - 20%);
        min-width: calc(100% - 20%);
        overflow: hidden;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0;
    }

    .icon-titulo {
        content: url('../../assets/imagenes_compartidas/icon-titulo.png');
        width: 0.7em;
    }

    h1 {
        color: $color-primary;
    }
</style>